import { Weekday } from '../helpers/time-utils';

type OpeningHours = {
    [key in Weekday]: {
        label: string;
        openTime: number | null;
        closeTime: number | null;
        openText: string;
        closeText: string;
    }[];
};

export const getOpeningHours = (key: Weekday) => {
    return openings[key];
};

const openings: OpeningHours = {
    mon: [
        {
            label: 'label.customerService',
            openText: '08.00',
            closeText: '18.00',
            openTime: 800,
            closeTime: 1800,
        },
        {
            label: 'label.claims',
            openText: '09.00',
            closeText: '16.00',
            openTime: 900,
            closeTime: 1600,
        },
    ],
    tue: [
        {
            label: 'label.customerService',
            openText: '08.00',
            closeText: '18.00',
            openTime: 800,
            closeTime: 1800,
        },

        {
            label: 'label.claims',
            openText: '09.00',
            closeText: '16.00',
            openTime: 900,
            closeTime: 1600,
        },
    ],
    wed: [
        {
            label: 'label.customerService',
            openText: '08.00',
            closeText: '18.00',
            openTime: 800,
            closeTime: 1800,
        },
        {
            label: 'label.claims',
            openText: '09.00',
            closeText: '16.00',
            openTime: 900,
            closeTime: 1600,
        },
    ],
    thu: [
        {
            label: 'label.customerService',
            openText: '08.00',
            closeText: '18.00',
            openTime: 800,
            closeTime: 1800,
        },
        {
            label: 'label.claims',
            openText: '09.00',
            closeText: '16.00',
            openTime: 900,
            closeTime: 1600,
        },
    ],
    fri: [
        {
            label: 'label.customerService',
            openText: '09.00',
            closeText: '17.00',
            openTime: 900,
            closeTime: 1700,
        },
        {
            label: 'label.claims',
            openText: '09.00',
            closeText: '16.00',
            openTime: 900,
            closeTime: 1600,
        },
    ],
    sat: [
        {
            label: 'label.customerService',
            openText: '',
            closeText: '',
            openTime: null,
            closeTime: null,
        },
        {
            label: 'label.claims',
            openText: '',
            closeText: '',
            openTime: null,
            closeTime: null,
        },
    ],
    sun: [
        {
            label: 'label.customerService',
            openText: '',
            closeText: '',
            openTime: null,
            closeTime: null,
        },
        {
            label: 'label.claims',
            openText: '',
            closeText: '',
            openTime: null,
            closeTime: null,
        },
    ],
    holiday: [
        {
            label: 'label.customerService',
            openText: '',
            closeText: '',
            openTime: null,
            closeTime: null,
        },
        {
            label: 'label.claims',
            openText: '',
            closeText: '',
            openTime: null,
            closeTime: null,
        },
    ],
};
